export default __webpack_public_path__ + "static/media/inview.43c9f875.jpg";